import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("footer", null, "© 2025 Stock·AI 版权所有 | 非经营性 | 公开数据 | 不提供投资建议 ");
}